import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SelectOption } from '@app/core/models/selector-option';
@Component({
  selector: 'app-overview-section-select',
  templateUrl: './overview-section-select.component.html',
  styleUrls: ['./overview-section-select.component.scss'],
})
export class OverviewSectionSelectComponent {
  private _value: any;

  get value(): any {
    return this._value;
  }

  @Input() set value(value: any) {
    this._value = value;

    if (value) {
      this.inputForm.setValue({
        option: value,
      });
    }
  }

  @Input()
  label: string;

  @Input()
  description: string;

  @Input()
  selectionOptions: SelectOption[];

  @Input()
  canCopy = false;

  @Input()
  copyLabel: string;

  @Input()
  noValueText: string;

  @Output()
  selectedValueChanged = new EventEmitter<string | number>();

  inputForm: UntypedFormGroup;

  onSelectedValueChanged(value: string | number) {
    this.selectedValueChanged.emit(value);
  }

  constructor() {
    this.inputForm = new UntypedFormGroup({
      option: new UntypedFormControl(''),
    });
  }
}
